"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryCarouselsView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const CategoryCarouselView_1 = require("../../categoryCarousel/views/CategoryCarouselView");
exports.CategoryCarouselsView = (0, react_1.forwardRef)(({ categories }, ref) => {
    return ((0, jsx_runtime_1.jsx)(ui_1.Stack, Object.assign({ kind: "vertical", ref: ref }, { children: categories.map((carousel) => ((0, jsx_runtime_1.jsx)(CategoryCarouselView_1.CategoryCarouselView, { products: carousel.products, category: carousel.title, description: carousel.description, slug: carousel.slug }, carousel.id))) })));
});
